exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reset[data-v-190a0287] {\n  padding-left: 27%;\n  padding-right: 27%;\n}\n@media (max-width: 400px) {\n.reset[data-v-190a0287] {\n      padding-left: 20px;\n      padding-right: 20px;\n}\n}\n@media (max-width: 540px) {\n.reset[data-v-190a0287] {\n      padding-left: 50px;\n      padding-right: 50px;\n}\n}\n", ""]);

// exports
